var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import Invite from './assets/banner-invite.svg';
import Premium from './assets/banner-premium.svg';
import PremiumAdmin from './assets/banner-premium-grey.svg';
var Container = styled.div.withConfig({ displayName: "Container", componentId: "sc-us2l8o" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n"], ["\n  cursor: pointer;\n  display: flex;\n"])));
var getBanner = function (lockReason) {
    switch (lockReason) {
        case 'premium':
            return _jsx(Premium, {}, void 0);
        case 'premium_admin':
            return _jsx(PremiumAdmin, {}, void 0);
        default:
            return _jsx(Invite, {}, void 0);
    }
};
var Banner = function (_a) {
    var lockReason = _a.lockReason, onClick = _a.onClick, rest = __rest(_a, ["lockReason", "onClick"]);
    return (_jsx(Container, __assign({ onClick: function () { return onClick(lockReason); } }, rest, { children: getBanner(lockReason) }), void 0));
};
export { Banner };
var templateObject_1;
